"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var DeviceModule = /** @class */ (function (_super) {
    __extends(DeviceModule, _super);
    function DeviceModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 下拉列表联动选择
     * @param parentId 父级Id 不传表示查询省份列表  传表示查询对应Id下的子级列表
     */
    DeviceModule.prototype.getDistrictSelective = function (parentId) {
        return this.gatewayClient.getDistrictSelective(parentId);
    };
    /**
     * 查询自助机型号列表
     */
    DeviceModule.prototype.queryMachineModelList = function (token) {
        return this.gatewayClient.queryMachineModelList(token);
    };
    /**
     * 查询自助机列表
     * @param chain
     * @param enable
     * @param machineCode
     * @param machineStatus
     */
    DeviceModule.prototype.queryMachineList = function (params, token) {
        return this.gatewayClient.queryMachineList(params, token);
    };
    /**
     * 添加自助机
     * @param machineCode
     * @param machineModel
     */
    DeviceModule.prototype.addMachine = function (machineCode, machineModel, userId, token) {
        return this.gatewayClient.addMachine(machineCode, machineModel, userId, token);
    };
    /**
     * 删除自助机
     * @param machineCode
     */
    DeviceModule.prototype.delMachine = function (machineCode, userId, token) {
        return this.gatewayClient.delMachine(machineCode, userId, token);
    };
    /**
     * 编辑自助机信息
     * @param city
     * @param district
     * @param enable
     * @param latitudeLongitude
     * @param machineCode
     * @param province
     * @param street
     */
    DeviceModule.prototype.editMachineInfo = function (params, token) {
        return this.gatewayClient.editMachineInfo(params, token);
    };
    /**
     * 查询未绑定门店
     * @param machineCode
     */
    DeviceModule.prototype.unbindedRoom = function (machineCode, chain, page, pageSize, token) {
        return this.gatewayClient.unbindedRoom(machineCode, chain, page, pageSize, token);
    };
    /**
     * 查询已绑定门店
     * @param machineCode
     */
    DeviceModule.prototype.bindedRoom = function (machineCode, token) {
        return this.gatewayClient.bindedRoom(machineCode, token);
    };
    /**
     * 绑定门店到机器
     * @param ids
     * @param machineCode
     */
    DeviceModule.prototype.bindingRoom = function (ids, machineCode, token) {
        return this.gatewayClient.bindingRoom(ids, machineCode, token);
    };
    /**
     * 解绑门店
     * @param chainId
     * @param machineCode
     */
    DeviceModule.prototype.unbindRoom = function (chainId, machineCode, token) {
        return this.gatewayClient.unbindRoom(chainId, machineCode, token);
    };
    /**
     * 根据id查询机器信息
     * @param id
     */
    DeviceModule.prototype.queryMachineInfoById = function (id, token) {
        return this.gatewayClient.queryMachineInfoById(id, token);
    };
    /**
     * 查询所有门锁
     * @param flter
     * @param orderBy
     * @param page
     * @param rows
     * @param sort
     */
    DeviceModule.prototype.queryAllLock = function (params, token) {
        return this.gatewayClient.queryAllLock(params, token);
    };
    /**
     * 获取门锁型号
     */
    DeviceModule.prototype.queryLockModel = function (token) {
        return this.gatewayClient.queryLockModel(token);
    };
    /**
     * 新增门锁
     * @param keySn
     * @param lockModelId
     * @param lockSn
     * @param netBoxSn
     * @param creator
     */
    DeviceModule.prototype.addLock = function (keySn, lockModelId, lockSn, netBoxSn, creator, token) {
        return this.gatewayClient.addLock(keySn, lockModelId, lockSn, netBoxSn, creator, token);
    };
    /**
     * 更新门锁
     * @param keySn
     * @param lockId
     * @param lockModelId
     * @param lockSn
     * @param netBoxSn
     * @param stat
     * @param updater
     */
    DeviceModule.prototype.updataLock = function (params, token) {
        return this.gatewayClient.updataLock(params, token);
    };
    /**
     * 更新门锁数据
     * @param lockId
     */
    DeviceModule.prototype.refreshLock = function (lockId, token) {
        return this.gatewayClient.refreshLock(lockId, token);
    };
    /**
     * 更新门锁状态
     * @param lockId
     */
    DeviceModule.prototype.refreshLockState = function (lockId, token) {
        return this.gatewayClient.refreshLockState(lockId, token);
    };
    /**
     * 校准门锁时间
     * @param lockId
     */
    DeviceModule.prototype.calibrateLockTime = function (lockId, token) {
        return this.gatewayClient.calibrateLockTime(lockId, token);
    };
    /**
     * 获取开门记录
     * @param beginDate
     * @param endDate
     * @param lockId
     */
    DeviceModule.prototype.lockopenLotg = function (filter, page, size, token) {
        return this.gatewayClient.lockopenLotg(filter, page, size, token);
    };
    /**
     * 获取门锁动态信息
     * @param lockId
     */
    DeviceModule.prototype.getLockDynamicsInfo = function (lockId, token) {
        return this.gatewayClient.getLockDynamicsInfo(lockId, token);
    };
    /**
     * 获取门锁密码列表
     */
    DeviceModule.prototype.getLockPasswordList = function (lockId, token) {
        return this.gatewayClient.getLockPasswordList(lockId, token);
    };
    /**
     * 重置密码
     * @param pwdId
     * @param pwdType
     * @param handlerName
     */
    DeviceModule.prototype.restLockPwd = function (pwdId, pwdType, handlerName, token) {
        return this.gatewayClient.restLockPwd(pwdId, pwdType, handlerName, token);
    };
    /**
     * 设置即时密码
     * @param endTime
     * @param isMaster 是否主锁（允许为空）
     * @param lockId
     * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码
     * @param remark
     * @param roomId
     * @param sn
     * @param startTime YYYY-MM-DD HH:mm:ss
     * @param writeTime
     */
    DeviceModule.prototype.setJustTimePwd = function (params, token) {
        return this.gatewayClient.setJustTimePwd(params, token);
    };
    /**
     * 设置超级密码
     * @param endTime
     * @param isMaster 是否主锁（允许为空）
     * @param lockId
     * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码
     * @param remark
     * @param roomId
     * @param sn
     * @param startTime YYYY-MM-DD HH:mm:ss
     * @param writeTime
     */
    DeviceModule.prototype.setSupperPwd = function (params, token) {
        return this.gatewayClient.setSupperPwd(params, token);
    };
    /**
     * 设置长租密码
     * @param endTime
     * @param isMaster 是否主锁（允许为空）
     * @param lockId
     * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码
     * @param remark
     * @param roomId
     * @param sn
     * @param startTime YYYY-MM-DD HH:mm:ss
     * @param writeTime
     */
    DeviceModule.prototype.setLongTimePwd = function (params, token) {
        return this.gatewayClient.setLongTimePwd(params, token);
    };
    /**
     * 设置离线密码
     * @param params
     * @param token
     */
    DeviceModule.prototype.setofflinePwd = function (params, token) {
        return this.gatewayClient.setofflinePwd(params, token);
    };
    /**
     * 关联房间
     * @param installTime
     * @param lockId
     * @param roomId
     * @param roomName
     */
    DeviceModule.prototype.relateRoom = function (installTime, lockId, roomId, roomName, token) {
        return this.gatewayClient.relateRoom(installTime, lockId, roomId, roomName, token);
    };
    /**
     * 解除关联
     * @param id
     * @param operateUserName
     */
    DeviceModule.prototype.unbindRoomRelation = function (id, operateUserName, token) {
        return this.gatewayClient.unbindRoomRelation(id, operateUserName, token);
    };
    /**
     * 根据id获取门店信息
     * @param roomId
     */
    DeviceModule.prototype.getRoomInfoById = function (roomId, token) {
        return this.gatewayClient.getRoomInfoById(roomId, token);
    };
    return DeviceModule;
}(gateway_module_1.GatewayModule));
exports.DeviceModule = DeviceModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/smart-device/index.js
// module id = 220
// module chunks = 44